import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom"
import { useLanguage } from '../i18n/LanguageContext';

const NotFound = () => {
  const { t } = useLanguage()

  return (
    <>
        <Helmet>
            <title>{t('meta404Title')}</title>
            <meta name="description" content={t('meta404Desc')} />
        </Helmet>
        <article className="notFound">
            <section className="notFound__imageSection">
                <picture className="notFound__picture">
                    <img src={require("../img/404-error.webp")} alt={t('alt404')}></img>
                </picture>
            </section>
            <section className="notFound__textSection">
                <div className="notFound__textSection__container">
                    <h2 className="notFound__title">{t('notFoundTitle')}</h2>
                    <p className="notFound__text">{t('notFoundText')}</p>
                    <Link to='/' className="notFound__button">{t('notFoundButton')}</Link>
                </div>
            </section>
        </article>
    </>
  )
}

export default NotFound
